module.exports = __webpack_public_path__ + "img/arrow-up-left-square.7ce927d0.svg";